import React from "react";
import {ThreeDots} from "react-loader-spinner";
import "./ViewLoadingSpinner.scss";

//** This component will display loader at the center of its parent element */

const ViewLoadingSpinner = () => {
  return (
    <div className="view-loading-spinner">
      <ThreeDots color={"#11cdef"} height="100" width="100" />
    </div>
  );
};

export default ViewLoadingSpinner;
